import { render } from "./Dividends.vue?vue&type=template&id=512ee05e&scoped=true"
import script from "./Dividends.vue?vue&type=script&lang=js"
export * from "./Dividends.vue?vue&type=script&lang=js"

import "./Dividends.vue?vue&type=style&index=0&id=512ee05e&scoped=true&lang=css"

import exportComponent from "E:\\Proj\\Apps\\Stock\\vuestock\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512ee05e"]])

export default __exports__